import React from 'react'
import { Link } from 'react-router-dom'
import { MARKETING_URL, routes } from '../../../constants/routes'

const InquiryLanding = () => {
    return (
        <>
            <div className="full-page-bg-img" style={{ backgroundImage: 'url("/img/bg/place-setting.jpg")' }} />
            <div className="inquiry-landing">
                <div className="inquiry-landing__header">
                    {/* clients arrive from the marketing site, so the logo takes them back there */}
                    <a href={MARKETING_URL}>
                        <img src="/img/icons/tivity-logo.png" alt="Tivity" width="120px" />
                    </a>
                    <h1>Book a Chef</h1>
                    <p>Tell us what you’re planning and we’ll match you with the perfect Chef, anywhere in the US.</p>
                </div>
                <div className="inquiry-landing__cards">
                    <Link to={routes.inquiryPrivateDinner.path} className="inquiry-card">
                        <h2>One Event</h2>
                        <p>Dinner, brunch, a cocktail party or a company gathering. Your Chef builds a one-of-a-kind menu around your occasion and brings the restaurant to you. All you have to do is enjoy the party.</p>
                        <span className="inquiry-card__cta">Book Now</span>
                    </Link>
                    <Link to={routes.inquiryMultiDay.path} className="inquiry-card">
                        <h2>A Few Days</h2>
                        <p>One Chef for the whole weekend, the family trip or the holiday house. Every meal planned around your days, so everyone gets to actually be there.</p>
                        <span className="inquiry-card__cta">Book Now</span>
                    </Link>
                    <Link to={routes.inquiryWeeklyMeals.path} className="inquiry-card">
                        <h2>Every Week</h2>
                        <p>Chef-prepared meals for your week, cooked in your home or delivered to you. Eat well on a regular Tuesday, without the cooking or another takeout order.</p>
                        <span className="inquiry-card__cta">Book Now</span>
                    </Link>
                </div>
            </div>
        </>
    )
}

export default InquiryLanding
